export default __webpack_public_path__ + "static/media/Hazelnut-Heritage-2.9c0ee20e.jpg";